//Merge Views
import main from 'Modules/realtimeMaps/main/lan/en';
import mainView from 'Modules/realtimeMaps/main/components/MapUtilitiesMenu/lan/en';
import vehicleList from 'Modules/realtimeMaps/main/components/VehicleList/lan/en';
import routes from 'Modules/realtimeMaps/main/components/routes/lan/en';
import vehicleTrail from 'Modules/realtimeMaps/main/components/VehicleTrails/lan/en';
import landmarks from 'Modules/realtimeMaps/main/components/LandmarksListMain/lan/en';
import landmarkMain from 'Modules/realtimeMaps/main/components/landmarks/lan/en';
import landmarkList from 'Modules/realtimeMaps/main/components/landmarks/components/landmarkList/lan/en';
import landmarkSettings from 'Modules/realtimeMaps/main/components/landmarks/components/landmarkSettings/lan/en';
import landmarkVisibleGroups from 'Modules/realtimeMaps/main/components/landmarks/components/landmarkVisibleGroups/lan/en';
import oldGeofence from 'Modules/realtimeMaps/main/components/GeofenceListMain/lan/en';
import geofence from 'Modules/realtimeMaps/main/components/geofences/lan/en';
import SendMessage from 'Modules/realtimeMaps/main/components/SendMessage/lan/en';
import vehicleDirections from 'Modules/realtimeMaps/main/components/VehicleDirections/lan/en';
import LayerMap from 'Modules/realtimeMaps/main/components/LayerMap/lan/en';
import findNearest from 'Modules/realtimeMaps/main/components/findNearest/lan/en';
import unitSelection from 'Modules/realtimeMaps/main/components/UnitSelection/lan/en';
import mapSetting from 'Modules/realtimeMaps/main/components/MapSetting/lan/en';
import eta from 'Modules/realtimeMaps/main/components/eta/lan/en';
import speedOverride from 'Modules/realtimeMaps/main/components/speedOverride/lan/en';
import vicinityTool from 'Modules/realtimeMaps/main/components/vicinityTool/lan/en';
import etaCreateEdit from 'Modules/realtimeMaps/main/components/eta/components/etaCreateEdit/lan/en';
import etaTable from 'Modules/realtimeMaps/main/components/eta/components/etaTable/lan/en';
import etaDelete from 'Modules/realtimeMaps/main/components/eta/components/etaDelete/lan/en';
import tagFilterMenu from '../../main/components/TagFilterAppliedMenu/lan/en';

//Module Keys
let locales = {
    ...main,
    ...mainView,
    ...vehicleList,
    ...routes,
    ...vehicleTrail,
    ...landmarks,
    ...landmarkMain,
    ...landmarkList,
    ...landmarkSettings,
    ...landmarkVisibleGroups,
    ...oldGeofence,
    ...geofence,
    ...SendMessage,
    ...vehicleDirections,
    ...LayerMap,
    ...findNearest,
    ...unitSelection,
    ...mapSetting,
    ...eta,
    ...speedOverride,
    ...vicinityTool,
    ...etaCreateEdit,
    ...etaTable,
    ...etaDelete,
    ...tagFilterMenu,
};

export default locales;
